<template>
    <form class="container p-0" @submit.prevent="forgotPassword">
        <div class="col input-group--forgot-pass">
            <div class="input-group">
                <input
                    type="email"
                    class="form-control"
                    placeholder="¿Cuál es tu correo?"
                    name="email"
                    v-model.lazy="email"
                    v-validate="'email|required'">
                <small class="text-validate d-block">
                   {{ errors.first('email')}}
                </small>
            </div>
            
            <div class="input-group-append">
                <button @click="forgotPassword" class="btn btn-outline-success" type="button">
                    {{ forgotPasswordText }}                        
                    <i class="fas" :class="icon"></i>
                </button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'ForgotPasswordForm',
    data() {
        return {
            email: '', 
            isLoading: false
        }
    },
    computed: {
        forgotPasswordText() {
            return this.isLoading ? 'Cargando': 'Restablecer';
        },
        icon() {
            return this.isLoading ? 'fa-spinner' : 'fa-paper-plane'
        }
    },
    methods: {
        async forgotPassword(){
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                this.isLoading = true;
                axios.post('v1/auth/forgot', {
                    email: this.email
                })
                .then(() => {
                    this.$emit('success');
                })
                .catch(() => {
                    this.$emit('error');
                })
                .finally(() => {
                    this.isLoading = false;
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.input-group--forgot-pass {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px;

    input {
        font-size: 14px;
        padding: 1.50rem 1.75rem;
        width: 100%;
        margin: 20px 0 0;
        border-radius: .25rem !important;

        &::placeholder {
            color: #C2C1C0;
        }

        &:focus {
            border-color:$border-color-gray;
            box-shadow: 0 0 0 0.2rem #ededed5c;
        }
    }

    .input-group-append {
        .btn-outline-success {
            padding: 0.75rem 1.93rem;
            color: $white-color;
            border-color: $orange-color;
            background-color: $orange-color;
            box-shadow:none!important;
            font-weight:600;
            margin-top: 20px;

            &:hover {
                background-color: $primary-color;
                border-color: $primary-color;
                box-shadow: 0 0 0 0.2rem #1f9b905c!important;
            }

            &:active {
                background-color: $primary-color!important;
                border-color: $primary-color!important;
            }
        }
    }

    .text-validate {
        color: $red-color;
        margin:10px 0 0;
    }
    .input-validate {
        border:1px solid $red-color;
    }
}
// Medium devices (tablet 991px)
@media screen and (max-width:991px) {
    .input-group--forgot-pass {
        input {
            width: 100%;
            border-radius: 0;
        }

        .input-group-append {
            margin-left: 0px;
            width: 100%;
            border-radius: 0;

            .btn-outline-success{
                padding: 1rem 1.93rem;
                width: 100%;
                border-radius: 0;
                margin-top: 15px;
            }
        }
    }
}
</style>